import React from "react";
import "./plan-list-carousel.scss";
import { ReactComponent as ArrowIcon } from "../../assets/icons/arrow.svg";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";

const CustomPrevArrow = (props) => {
  const { className, onClick } = props;

  const { buttons } = useInitialConfigStore.getState((state) => state).theme;

  return (
    <div
      className={`${className} arrow-prev custom-prev-arrow-plans`}
      onClick={onClick}
      style={{
        backgroundColor: buttons.backgroundColor,
      }}
    >
      <ArrowIcon fill={buttons.color ? buttons.color : "#ffffff"} />
    </div>
  );
};

const CustomNextArrow = (props) => {
  const { className, onClick } = props;

  const { buttons } = useInitialConfigStore.getState((state) => state).theme;

  return (
    <div
      className={`${className} arrow-next custom-next-arrow-plans`}
      onClick={onClick}
      style={{
        backgroundColor: buttons.backgroundColor,
      }}
    >
      <ArrowIcon fill={buttons.color ? buttons.color : "#ffffff"} />
    </div>
  );
};

export { CustomPrevArrow, CustomNextArrow };
